import { CbhIcon } from "@clipboard-health/ui-components";
import { CircularProgress } from "@mui/material";

interface LocationStatusRowIconProps {
  state: "loading" | "connected" | "failed";
}

export function LocationStatusRowIcon(props: LocationStatusRowIconProps) {
  const { state } = props;

  if (state === "loading") {
    return <CircularProgress size={24} />;
  }

  if (state === "connected") {
    return <CbhIcon type="checkmark" size="medium" color={(theme) => theme.palette.success.main} />;
  }

  return (
    <CbhIcon
      type="triangle-exclamation"
      size="medium"
      color={(theme) => theme.palette.error.main}
    />
  );
}
